<div class="app-admin-wrap">
  <mat-drawer-container class="ebo-drawer-container" hasBackdrop="true">
    <mat-drawer #drawer mode="over">
      <div [ngClass]="{ 'sidenav-wrapper': true }" style="height: 100%">
        <ebo-sidenav [menuLeft]="true" [drawer]="drawer"></ebo-sidenav>
      </div>
    </mat-drawer>
    <mat-drawer-content>
      <ebo-top-header [drawer]="drawer"></ebo-top-header>

      <div id="main-wrapper" [ngClass]="{ 'blurred': drawer.opened }">
        <ng-container *ngIf="(isBotCreated$ | async) && !isOnDashboard">
          <div class="sidenav-wrapper">
            <ebo-sidenav></ebo-sidenav>
            <button
              (click)="drawer.toggle()"
              matTooltip="Open menu"
              matTooltipPosition="right"
              class="open-menu-btn drawer-toggle-btn"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <path d="M31.9783 9.63978C31.9764 9.59632 31.9752 9.55406 31.9727 9.52509C31.8065 7.69667 30.7651 5.99925 29.1872 4.98514C28.3467 4.44488 27.3791 4.11348 26.3904 4.02656C26.3632 4.02415 26.3222 4.02294 26.2794 4.02113C26.1858 4.01751 26.1051 4.01388 26.0363 4H5.96185C5.89673 4.01449 5.82106 4.0169 5.72988 4.02052C5.68708 4.02233 5.64367 4.02354 5.60955 4.02656C2.60257 4.29156 0.19662 6.72784 0.0142658 9.6935C0.012405 9.72248 0.00930377 9.75025 0.00620251 9.77801C0.00310126 9.80819 0 9.83234 0 9.85528V22.1296C0 22.1586 0.00310126 22.1882 0.00682276 22.2226C0.00992402 22.2504 0.012405 22.2787 0.0142658 22.3089C0.129012 24.1627 1.14064 25.8993 2.71918 26.9545C3.63281 27.5654 4.69096 27.9221 5.7795 27.9855C5.81237 27.9873 5.84277 27.9903 5.87254 27.994C5.90355 27.9976 5.92836 28 5.95131 28H26.0481C26.071 28 26.0958 27.9976 26.1268 27.994C26.1566 27.9909 26.187 27.9873 26.2193 27.9855C27.2104 27.927 28.1873 27.6221 29.0445 27.1042C30.7062 26.0985 31.8009 24.3679 31.9727 22.4749C31.9752 22.4459 31.9764 22.4067 31.9783 22.3675C31.982 22.2769 31.9851 22.2009 32 22.1357V9.86313C31.9839 9.78767 31.9814 9.70799 31.9783 9.63978ZM28.0527 25.2293C27.4219 25.6446 26.6807 25.874 25.911 25.8915H25.9042H12.1526V6.10911H25.8874C26.5771 6.12299 27.2483 6.30589 27.8356 6.6391C29.0861 7.3526 29.8626 8.6637 29.8626 10.0605L29.8645 21.9178C29.8645 23.2518 29.1872 24.4899 28.0527 25.2293Z" fill="white"/>
              </svg>
            </button>
          </div>
        </ng-container>

        <div
          [ngClass]="{
            'content-wrapper': true,
            'custom-margin-left': isOnDashboard
          }"
        >
          <div class="content-container" id="content-container">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
